import React from "react";

const GrowerAgreements = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Grower Agreements</h5>
      </div>

      <div className="about-box p-4 rounded shadow-lg " style={{textAlign:'justify',overflow:'hidden'}}>
        <div className="text-end">
          <p>
            Serial No. ...............
            <br />
            Agreement No. ............
          </p>
        </div>

        <h6>AGREEMENT</h6>

        <p>
          This Agreement is executed at Regional Office
          ...........................................
          this day
          .....................................
          of
          ..........................
          2010 .........................
          BETWEEN the Haryana Seeds Development Corporation Ltd. for short here
          in after referred to as HSDC Ltd. a company registered under the
          Companies Act, 1956 having its registered office at Panchkula, Haryana
          (who and whose successors and assignees are here in after called the
          HSDC Ltd. One part) AND
          <br />
          <div className="me-2 overflow-hidden">
          ....................................................................................................................................................................................................
          </div>
          <div className="me-2 overflow-hidden">
          ....................................................................................................................................................................................................
          </div>
          <div className="me-2 overflow-hidden">
          ....................................................................................................................................................................................................
          </div>
          (address of the grower in full in block letters) who and whose heirs,
          legal representatives and successors are herein after called the
          Grower of the OTHER PART, on the date mentioned under the signature of
          the Regional Manager / Manager signing on behalf of the Registered
          Office of the company
        </p>

        <p>
          &nbsp;&nbsp; WHEREAS the Haryana Seeds Development Corporation Ltd.
          and the Seed Grower Agreed to a scheme for the production of
          Foundation Stock / Certified / Pedigree category of seed of
        </p>

        <p>
        <div className="me-2 overflow-hidden">
        .....................................................................................................................................................................
          crop of
        </div>
          <div className="me-2 overflow-hidden">
          .....................................................................................................................................................................
          variety of
          </div>
        </p>

        <p>
        <div className="me-2 overflow-hidden">
        ........................................................................................................</div>
          .....................................acres during the Kharif / Rabi /
          Summer of
          ...........................................................
          (year) under the Haryana Seeds Development Corporation Ltd.
          Grower&rsquo;s Program approved by State Seed Production Committee.
        </p>

        <h5>NOW THIS AGREEMENT WITNESSETH</h5>

        <ol>
          <li>
            That the terms and conditions contracted herein, including those as
            incorporated in the schedule-1 attached to this agreement shall be
            binding on the parties here to and their relationship shall be
            governed by the same.
          </li>
          <li>
            All payments payable or claimable under this agreement shall be paid
            and claimed at H.S.D.C. Ltd.&rsquo;s Regional Office or by mutual
            consent, at Panchkula, or any other station(s).
          </li>
          <li>
            Notwithstanding the place where this agreement is to be implemented,
            it is mutually understood and agreed by and between the parties
            hereto that this contract shall be deemed to have been entered into
            by the parties concerned at Regional Office and the Court of law in
            ....................................................
            (Place) alone shall have jurisdiction to adjudicate thereon.
          </li>
          <li>
            This program means the program of Rabi / Kharif / Summer seed
            production approved by State Seed Production Committee.
          </li>
        </ol>

        <p>
          IN WITNESS WHEREOF, the parties have set their hands on the day, month
          and year mentioned below:-
        </p>

        <div className=" row">
            <div className="col-4 overflow-hidden">
          <p className="pe-2">
            ________________________
            <br />
            (Signature of Grower)
          </p>
          </div>
          <div className="col-8 overflow-hidden">
          <p className="text-end ms-auto px-2">
            _________________________________________________
            <br />
            Signature of the Regional Manager / Manager
            <br />
            and on behalf of H.S.D.C. Ltd.
            <br />
            (A State Govt. Undertaking)
          </p>
        </div>
        </div>

          <h5>WITNESS</h5>
        <div className="row">

        <div className="col-4 overflow-hidden ">
            <h6>SIGNATURE</h6>
            <p>1._______________</p>
            <p>2._______________</p>
          </div>

          <div className="col-3 overflow-hidden">
            <h6>DATE</h6>

            <p>_______________</p>

            <p>_______________</p>
          </div>

          <div className="col-5 overflow-hidden text-end">
            <h6>NAME &amp; ADDRESS</h6>

            <p>
              Name __________________________
              <br />
              Father&#39;s Name _________________
              <br />
              Address ________________________
              <br />
              _________________________________
              <br />
              _________________________________
            </p>

            <p>
              Name __________________________
              <br />
              Father&rsquo;s Name _________________
              <br />
              Address ________________________
              <br />
              _________________________________
              <br />
              _________________________________
            </p>
          </div>
        </div>

        <p>
          <strong>
            Note: The contents of this page alone need be got typed on
            non-judicial paper of the required value.
          </strong>
        </p>

        <h5 className="center-align">SCHEDULE-1</h5>

        <p>
          The terms and conditions agreed upon BETWEEN the parties hereto
          regarding the scheme for the production of Foundation
          Stock/Certified/Pedigree category of seed of
          ....................................................
          crop of
          ....................................................
          (variety) during the Kharif/Rabi/Summer of
          ....................................................
          under the Haryana Seeds Development Corporation Ltd. Grower&rsquo;s
          program are as under.
        </p>

        <ol>
          <li>
            The value of stamp paper relating to this agreement is recoverable
            from the grown, along with seed cost, Registration fee &amp;
            inspection fee or from the amount payable to the grower.
          </li>
          <li>
            <ol type="a">
              <li>
                The grower shall reserve/set apart an area for seed production
                measuring
                .......................... acre(s)
                (in words)
                ....................................................
                which shall be a compact block/piece of land of not less than
                ..........................
                acres unless mutually agreed in writing. This reserved area
                shall be neither scattered nor in small bits.
              </li>
              <li>
                The reserved area shall so located that the seed crop in that
                area will conform to the isolation requirement prescribed in the
                Indian Minimum Seed Certification Standards July, 1998 as
                amended from time to time, (Unless specified, if any) failing
                which the seed crop shall be liable to be rejected in part or
                full as may be necessary.
              </li>
              <li>
                The Grower shall raise the seed crop as a single crop and not as
                mixed crop, inter crop or companion crop. Nor seed crop be
                raised as a ratoon crop without prior approval of the H.S.D.C.
                Ltd.
              </li>
              <li>
                The grower shall arrange all operations such as land
                preparation, sowing, irrigation, interculture, manuring, plant
                protection, rouging, detaselling (in Maize), harvesting and any
                other farm operation connected with the raising of the seed crop
                and shall strictly follow the seed production practices
                prescribed by CCS, HAU from time to time at his expenses.
              </li>
            </ol>
          </li>
          <li>
            <ol type="a">
              <li>
                Seed to be used for sowing by the grower shall be obtained from
                H.S.D.C. Ltd. only.
              </li>
              <li>
                The grower shall pay to the H.S.D.C. Ltd. the seed cost, plus
                sale tax, if application in advance at the rate fixed by
                H.S.D.C. Ltd. The cost of seed is not refundable except under
                the provision contained in clause 3(c)
              </li>
              <li>
                In case the seed supplied by H.S.D.C Ltd., is proved to be
                defective to the satisfaction of H.S.D.C. Ltd., the H.S.D.C.
                Ltd., shall replace the defective seed or refund seed cost, at
                its option, provided due intimation in writing is giving to be
                concerned Regional Office of H.S.D.C. Ltd., within 10 days of
                sowing along with supporting documents of receipt consignment.
                On receipt of the complaint, the RM/his representative will
                inspect the seed plots as soon as possible but not later than 7
                days of receipt of complaint. Seed cost will be refunded if upon
                inspection it is established that cause of failure is
                attributable to seed supplied by HSDC.
              </li>
              <li>
                The grower shall not sell or transfer the Breeder/Foundation
                stock seed/Pedigree seed obtained from the Haryana Seeds
                Development Corporation to any other person.
              </li>
            </ol>
          </li>
          <li>
            For seed production of notified kinds/varieties in Haryana, the
            grower shall submit to the certification agency an application for
            certification through H.S.D.C. Ltd., as prescribed in the Seeds
            Rules, 1968 as amended from time to time. The
            application/registration fee is not-refundable. One application can
            cover the entire area of all the seed crops of notified
            kinds/varieties grown in a season by one grower.
          </li>
          <li>
            The grower shall pay in advance to the H.S.D.C Ltd. inspection fee
            at the rate of Rs
            .......................... per acre
            and registration fee of Rs. 25/- or as revised by HSSCA from time to
            time.
          </li>
          <li>
            The grower shall render all facilities to the certification
            Agency/H.S.D.C. Ltd. for conducting field inspections of seed crop
            (s) at any time and at any stage.
          </li>
          <li>
            <ol type="a">
              <li>
                Produce of the Breeder/Foundation/C to C seed supplied by HSDC
                Ltd. Only will be acceptable for grading &amp; testing out area
                certified by HSSCA.
              </li>
              <li>
                No Raw seed qty. exceeding HSSCA estimates or limit fixed by
                HSDC Ltd. will be acceptable by H.S.D.C. Ltd. for grading and
                testing. Further the seed offered by the growers should meet the
                internal quality control standards, fixed by the H.S.D.C Ltd.
              </li>
              <li>
                Seed only from the part of the reserved area conforming to the
                standards referred to in 2 (b) shall be accepted and graded.
              </li>
              <li>
                The grower shall arrange to transport the harvested and thrashed
                seed material to the HSDC Ltd. plant (s) assigned by the
                H.S.D.C. Ltd. or the State Seed Certification Agency as the case
                may be in gunny bags which will be supplied by the H.S.D.C. Ltd.
                against post-dated cheques on account of the cost of G.bags.
              </li>
              <li>
                For seed production involving two parental lines, the H.S.D.C
                Ltd. will not grade or purchase of the male parent. The grower
                shall not sell or use such produce for sowing.
              </li>
              <li>
                In case of seed Cotton produce of Breeder/Foundation/C to C seed
                supplied by HSDC Ltd. will be acceptable out of area certified
                by HSSCA subject to the internal quality standards.
              </li>
              <li>
                Grading of seed in the manner prescribed by the H.S.D.C. Ltd.
                shall done in the nearest Seed Processing Plant of H.S.D.C. Ltd.
                or in a plant designed by it.
              </li>
              <li>
                If before or after grading in the manner prescribed by the
                H.S.D.C. Ltd. the seed lot does not confirm to the seed
                standards prescribed in the Indian Minimum Seed certification
                Standards July 1988, as amended from time to time (unless
                specified, if any) if will stand rejected &amp; returned to
                concerned grower after recovering dues along with grading
                charges at prescribed rates.
              </li>
              <li>
                The H.S.D.C. Ltd shall make all possible efforts to expedite the
                grading. The H.S.D.C. Ltd shall not be responsible for any
                deterioration in the produce till it is finally purchased.
              </li>
            </ol>
          </li>
          <li>
            <ol type="a">
              <li>
                Representative lotwise sample (s) of the cleaned and graded seed
                on random basis belonging to the grower shall be drawn by HSSCA
                representative and will be sent for testing in Lab. in the name
                of grower. If, a seed lot is found as not conforming to the
                prescribed standards and is rejected, the retesting by
                HSDC/HSSCA will be done at the option of HSDC depending upon the
                circumstances.
              </li>
              <li>
                For analysis of seed sample(s), the H.S.D.C. Ltd/Certification
                Agency will levy testing fee per sample irrespective of the
                nature of results of analysis.
              </li>
            </ol>
          </li>
          <li>
            In addition to conforming to the standards referred in clause 7 (g),
            the H.S.D.C. Ltd. reserves the right of reject or not to procure any
            lot (s), if the seed there is in discoloured, lustre affected,
            infested with inspects, pests and disease or any other reason not
            covered under Minimum Seeds Certification Standards even though the
            Seed Lot (s) has been cleared by Seed Certification Agency and meets
            the Minimum Seed Certification Standards.
          </li>
          <li>
            The grower shall take back from the Seed Plant the rejected raw seed
            rejected ears, wastes seeds discards, under-sized seeds, empty cobs
            etc, after cleaning and grading and seed lots rejected on the basis
            of test reports within 31 days from the date of processing/date of
            intimation whichever is earlier, failing which rent at the rate
            fixed by HSDC Ltd. from time to time shall be charged after the
            expiry of the prescribed period. The grower shall not sell or use
            such produce as seed for sowing. Also the H.S.D.C Ltd. will not be
            responsible for any damage to the material during the period of the
            storage. The H.S.D.C Ltd. reserves the right to dispose off the
            produce in the manner as deemed fit, after the expiry of the
            prescribed period and recover the rent due and credit balance, if
            any to the grower&rsquo;s account.
          </li>
          <li>
            <ol type="a">
              <li>
                The H.S.D.C. Ltd. shall purchase graded seed (i.e.) seed finally
                received bags after grading conforming to the seed standards
                referred to in clause 7(g) of this agreement at the procurement
                price fixed by the HSDC Ltd. as per policy approved by
                B.O.D/Management from time to time. The procurement rate shall
                be reasonably higher than support price fixed by G.O.I.
              </li>
              <li>
                The Purchase price shall be deemed to be an all inclusive price
                and no other claim including tax(es), if any, leviable shall
                entertained. The H.S.D.C. Ltd. shall be entitled to recover the
                amount due from the grower from the amount payable to the
                grower.
              </li>
              <li>
                Entire produce, as estimated on the basis of the crop condition
                indicated in the final field inspection report of HSSCA/HSDC
                from the certified area and confirming to the prescribed
                standards as per annexure enclosed shall be offered to the
                H.S.D.C. Ltd. by the grower who shall not sell or transfer to
                anyone else the produce eligible for grading/testing by the
                H.S.D.C. Ltd. in case of default, the grower shall be liable to
                pay to the H.S.D.C. Ltd. loss suffered by H.S.D.C. Ltd on this
                account
              </li>
            </ol>
          </li>
          <li>
            In the event of any question, dispute or difference arising from,
            under or in connection with this agreement, its implementation or
            satisfaction, the same shall be referred to an arbitrator by the
            M.D., H.S.D.C. Ltd. The parties to this agreement shall have no
            objection if the arbitrator nominated as above is a person who has
            or had dealt with the matter to which the contract relates or that
            in the course of his duties he has expressed views on all or any of
            the matter in dispute or difference. The decision of the Arbitrator
            shall be final and binding on both the parties.
          </li>
        </ol>
      </div>
    </div>
  );
};

export default GrowerAgreements;
